import { render } from "./chatBody.vue?vue&type=template&id=59fe086d"
import script from "./chatBody.vue?vue&type=script&lang=js"
export * from "./chatBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__